import { createRouter, createWebHistory } from "vue-router";

// Layout components
import PublicLayout from "./layouts/PublicLayout.vue";
import MemberLayout from "./layouts/MemberLayout.vue";
import AdminLayout from "./layouts/AdminLayout.vue";

// 首页同步加载（保持首屏直出）
import vueIndex from "./components/VueIndex.vue";

// 其余路由全部懒加载，按功能分 chunk（webpackChunkName）
const aboutOur = () => import(/* webpackChunkName: "about" */ "./components/AboutWe.vue");
const AboutBan = () => import(/* webpackChunkName: "about" */ "./components/AboutBan.vue");

const productVue1 = () => import(/* webpackChunkName: "tech" */ "./components/Technical1.vue");
const productVue2 = () => import(/* webpackChunkName: "tech" */ "./components/Technical2.vue");
const productVue3 = () => import(/* webpackChunkName: "tech" */ "./components/Technical3.vue");
const productVue4 = () => import(/* webpackChunkName: "tech" */ "./components/Technical4.vue");
const productListVue = () => import(/* webpackChunkName: "tech" */ "./components/TechnicalList.vue");

const yewuVue = () => import(/* webpackChunkName: "product" */ "./components/ProductServices.vue");
const LayList = () => import(/* webpackChunkName: "product" */ "./components/productList/LayList.vue");
const productDetail = () => import(/* webpackChunkName: "product" */ "./components/productList/productDetail.vue");
const OrderList = () => import(/* webpackChunkName: "product" */ "./components/productList/OrderList.vue");
const ProductDetail = () => import(/* webpackChunkName: "product" */ "./components/ProductDetail.vue");
const microspheresDetailVue = () => import(/* webpackChunkName: "product" */ "./components/productList/microspheresDetail.vue");

const hydrogelDetailVue01 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_01.vue");
const hydrogelDetailVue02 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_02.vue");
const hydrogelDetailVue03 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_03.vue");
const hydrogelDetailVue04 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_04.vue");
const hydrogelDetailVue05 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_05.vue");
const hydrogelDetailVue06 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_06.vue");
const hydrogelDetailVue07 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_07.vue");
const hydrogelDetailVue08 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_08.vue");
const hydrogelDetailVue09 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_09.vue");
const hydrogelDetailVue10 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_10.vue");
const hydrogelDetailVue11 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_11.vue");
const hydrogelDetailVue12 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_12.vue");
const hydrogelDetailVue13 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_13.vue");
const hydrogelDetailVue14 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_14.vue");
const hydrogelDetailVue15 = () => import(/* webpackChunkName: "hydrogel" */ "./components/productList/hydrogelDetail_15.vue");

const ProductListLiposomes = () => import(/* webpackChunkName: "liposomes" */ "./components/productList/ProductListLiposomes.vue");
const LiposomesDetail_01Vue = () => import(/* webpackChunkName: "liposomes" */ "./components/productList/LiposomesDetail_01.vue");
const LiposomesDetail_02Vue = () => import(/* webpackChunkName: "liposomes" */ "./components/productList/LiposomesDetail_02.vue");
const LiposomesDetail_03Vue = () => import(/* webpackChunkName: "liposomes" */ "./components/productList/LiposomesDetail_03.vue");

const CellMembraneExtractionVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/CellMembraneExtraction.vue");
const CouplingLabelingVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/CouplingLabeling.vue");
const CustomizationVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/Customization.vue");
const ExosomesVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/Exosomes.vue");
const IsotopeCompoundsVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/IsotopeCompounds.vue");
const LNPproteinVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/LNPprotein.vue");
const OligonucleotideSynthesisVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/OligonucleotideSynthesis.vue");
const PeptideVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/Peptide.vue");
const PNAVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/PNA.vue");
const ProteinVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/Protein.vue");
const ProteinCrystalStructureVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/ProteinCrystalStructure.vue");
const TechnicalServiceVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/TechnicalService.vue");
const DrugConjugatesVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/DrugConjugates.vue");
const AntibodyDrugconJugateVue = () => import(/* webpackChunkName: "techservice" */ "./components/technicalservice/AntibodyDrugconJugate.vue");

const newList = () => import(/* webpackChunkName: "news" */ "./components/NewsCenter.vue");
const newShow = () => import(/* webpackChunkName: "news" */ "./components/NewsShow.vue");

const downListVue = () => import(/* webpackChunkName: "download" */ "./components/DownList.vue");

const Login = () => import(/* webpackChunkName: "auth" */ "./views/LoginNew.vue");
const ForgetPassword = () => import(/* webpackChunkName: "auth" */ "./views/ForgetPassword.vue");
const RegisterVue = () => import(/* webpackChunkName: "auth" */ "./views/Register.vue");

const MemberCenter = () => import(/* webpackChunkName: "member" */ "./views/MemberCenter.vue");
const AddressManager = () => import(/* webpackChunkName: "member" */ "./views/AddressManager.vue");
const SecurityCenter = () => import(/* webpackChunkName: "member" */ "./views/SecurityCenter.vue");
const OrderDetailsPage = () => import(/* webpackChunkName: "member" */ "./views/OrderDetailsPage.vue");
const payCallback = () => import(/* webpackChunkName: "member" */ "./views/payCallback.vue");

const PaymentContainer = () => import(/* webpackChunkName: "order" */ "./views/paymentcontainer.vue");

//后台管理
const LoginAdmin = () => import(/* webpackChunkName: "admin" */ "./views/admin/adminLogin.vue");
const AdminCenter = () => import(/* webpackChunkName: "admin" */ "./views/admin/AdminCenter.vue");
const OrderDetailsPageAdmin = () => import(/* webpackChunkName: "admin" */ "./views/admin/OrderDetailsPageAdmin.vue");
const AdminNewsEditor = () => import(/* webpackChunkName: "admin" */ "./views/admin/NewsEditor.vue");
const adminNewsShow = () => import(/* webpackChunkName: "admin" */ "./views/admin/adminNewsShow.vue");
const adminNewsModify = () => import(/* webpackChunkName: "admin" */ "./views/admin/adminModifyNews.vue");

const routes = [
  // ── Public pages (wrapped by PublicLayout) ──
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: vueIndex,
      },
      {
        path: "AboutWe",
        name: "About",
        component: aboutOur,
      },
      {
        path: "AboutBan",
        name: "AboutBan",
        component: AboutBan,
      },
      {
        path: "Technical1",
        name: "Product1",
        component: productVue1,
      },
      {
        path: "Technical2",
        name: "Product2",
        component: productVue2,
      },
      {
        path: "Technical3",
        name: "Product3",
        component: productVue3,
      },
      {
        path: "Technical4",
        name: "Product4",
        component: productVue4,
      },
      {
        path: "TechnicalList",
        name: "ProductList",
        component: productListVue,
      },
      {
        path: "DownList",
        name: "DownList",
        component: downListVue,
        props: (route) => ({ index: route.query.index }),
      },
      {
        path: "ProductServices",
        name: "zhuyingyewu",
        component: yewuVue,
      },
      {
        path: "NewsCenter",
        name: "newVue",
        component: newList,
      },
      {
        path: "productDetail",
        name: "productDetail",
        component: productDetail,
      },
      {
        path: "ProductListLiposomes",
        name: "ProductListLiposomes",
        component: ProductListLiposomes,
      },
      {
        path: "LiposomesDetail_01",
        name: "LiposomesDetail_01",
        component: LiposomesDetail_01Vue,
      },
      {
        path: "LiposomesDetail_02",
        name: "LiposomesDetail_02",
        component: LiposomesDetail_02Vue,
      },
      {
        path: "LiposomesDetail_03",
        name: "LiposomesDetail_03",
        component: LiposomesDetail_03Vue,
      },
      {
        path: "ShowNews",
        name: "ShowNews",
        component: newShow,
      },
      {
        path: "products/:id",
        name: "ProductDetail",
        component: ProductDetail,
        meta: { breadcrumb: (route) => `产品 ID: ${route.params.id}` },
      },
      {
        path: "LayList",
        name: "LayList",
        component: LayList,
        props: (route) => ({ index: route.query.index }),
      },
      {
        path: "pages/money/paySuccess",
        name: "payCallback",
        component: payCallback,
      },
      {
        path: "hydrogelDetail01",
        name: "hydrogelDetail01",
        component: hydrogelDetailVue01,
      },
      {
        path: "hydrogelDetail02",
        name: "hydrogelDetail02",
        component: hydrogelDetailVue02,
      },
      {
        path: "hydrogelDetail03",
        name: "hydrogelDetail03",
        component: hydrogelDetailVue03,
      },
      {
        path: "hydrogelDetail04",
        name: "hydrogelDetail04",
        component: hydrogelDetailVue04,
      },
      {
        path: "hydrogelDetail05",
        name: "hydrogelDetail05",
        component: hydrogelDetailVue05,
      },
      {
        path: "hydrogelDetail06",
        name: "hydrogelDetail06",
        component: hydrogelDetailVue06,
      },
      {
        path: "hydrogelDetail07",
        name: "hydrogelDetail07",
        component: hydrogelDetailVue07,
      },
      {
        path: "hydrogelDetail08",
        name: "hydrogelDetail08",
        component: hydrogelDetailVue08,
      },
      {
        path: "hydrogelDetail09",
        name: "hydrogelDetail09",
        component: hydrogelDetailVue09,
      },
      {
        path: "hydrogelDetail10",
        name: "hydrogelDetail10",
        component: hydrogelDetailVue10,
      },
      {
        path: "hydrogelDetail11",
        name: "hydrogelDetail11",
        component: hydrogelDetailVue11,
      },
      {
        path: "hydrogelDetail12",
        name: "hydrogelDetail12",
        component: hydrogelDetailVue12,
      },
      {
        path: "hydrogelDetail13",
        name: "hydrogelDetail13",
        component: hydrogelDetailVue13,
      },
      {
        path: "hydrogelDetail14",
        name: "hydrogelDetail14",
        component: hydrogelDetailVue14,
      },
      {
        path: "hydrogelDetail15",
        name: "hydrogelDetail15",
        component: hydrogelDetailVue15,
      },
      {
        path: "microspheresDetail",
        name: "microspheresDetail",
        component: microspheresDetailVue,
      },
      {
        path: "CellMembraneExtraction",
        name: "CellMembraneExtractionVue",
        component: CellMembraneExtractionVue,
      },
      {
        path: "CouplingLabeling",
        name: "CouplingLabelingVue",
        component: CouplingLabelingVue,
      },
      {
        path: "Customization",
        name: "CustomizationVue",
        component: CustomizationVue,
      },
      {
        path: "Exosomes",
        name: "ExosomesVue",
        component: ExosomesVue,
      },
      {
        path: "IsotopeCompounds",
        name: "IsotopeCompoundsVue",
        component: IsotopeCompoundsVue,
      },
      {
        path: "LNPprotein",
        name: "LNPproteinVue",
        component: LNPproteinVue,
      },
      {
        path: "OligonucleotideSynthesis",
        name: "OligonucleotideSynthesisVue",
        component: OligonucleotideSynthesisVue,
      },
      {
        path: "Peptide",
        name: "PeptideVue",
        component: PeptideVue,
      },
      {
        path: "PNA",
        name: "PNAVue",
        component: PNAVue,
      },
      {
        path: "Protein",
        name: "ProteinVue",
        component: ProteinVue,
      },
      {
        path: "ProteinCrystalStructure",
        name: "ProteinCrystalStructureVue",
        component: ProteinCrystalStructureVue,
      },
      {
        path: "TechnicalService",
        name: "TechnicalServiceVue",
        component: TechnicalServiceVue,
      },
      {
        path: "AntibodyDrugconJugate",
        name: "AntibodyDrugconJugate",
        component: AntibodyDrugconJugateVue,
      },
      {
        path: "DrugConjugates",
        name: "DrugConjugatesVue",
        component: DrugConjugatesVue,
      },
    ],
  },

  // ── Member pages (wrapped by MemberLayout, requires auth) ──
  {
    path: "/",
    component: MemberLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "MemberCenter",
        name: "MemberCenter",
        component: MemberCenter,
      },
      {
        path: "AddressManager",
        name: "AddressManager",
        component: AddressManager,
      },
      {
        path: "SecurityCenter",
        name: "SecurityCenter",
        component: SecurityCenter,
      },
      {
        path: "OrderDetailsPage",
        name: "OrderDetailsPage",
        component: OrderDetailsPage,
      },
      {
        path: "PaymentContainer",
        name: "PaymentContainer",
        component: PaymentContainer,
      },
      {
        path: "Order",
        name: "Order",
        component: OrderList,
      },
    ],
  },

  // ── Admin pages (wrapped by AdminLayout, requires admin) ──
  {
    path: "/",
    component: AdminLayout,
    meta: { requiresAdmin: true },
    children: [
      {
        path: "AdminCenter",
        name: "AdminCenter",
        component: AdminCenter,
      },
      {
        path: "OrderDetailsPageAdmin",
        name: "OrderDetailsPageAdmin",
        component: OrderDetailsPageAdmin,
      },
      {
        path: "NewsShowAdmin",
        name: "adminNewsShow",
        component: adminNewsShow,
      },
      {
        path: "NewsModifyAdmin",
        name: "adminNewsModify",
        component: adminNewsModify,
      },
      {
        path: "NewsEditor",
        name: "AdminNewsEditor",
        component: AdminNewsEditor,
      },
    ],
  },

  // ── Standalone pages (no layout) ──
  {
    path: "/Login",
    name: "Login",
    component: Login,
  },
  {
    path: "/RegisterVue",
    name: "RegisterVue",
    component: RegisterVue,
  },
  {
    path: "/ForgetPassword",
    name: "ForgetPassword",
    component: ForgetPassword,
  },
  {
    path: "/LoginAdmin",
    name: "LoginAdmin",
    component: LoginAdmin,
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    ...routes,
    { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("./views/NotFound.vue") },
  ],
});

router.beforeEach((to, from, next) => {
  const token   = localStorage.getItem('token');
  const isAdmin = localStorage.getItem('admin') === 'true'; // 严格匹配，规避 "false" 字符串坑
  if (to.meta?.requiresAdmin) {
    if (!token || !isAdmin) return next({ path: '/LoginAdmin' });
  } else if (to.meta?.requiresAuth) {
    if (!token) return next({ path: '/Login' });
  }
  next();
});

export default router;
